module.exports = __webpack_public_path__ + "img/3-1.79fee8d6.gif";